<template>
  <section>
    <div class="titulo">
      <div class="margem container">
        <button type="button" class="link-voltar" @click="voltarAnterior">
          <i class="fa-solid fa-arrow-left"></i> Voltar à tela anterior
        </button>
        <h2>Histórico de visitas</h2>
        <p v-if="visitantes.length === 1" class="subtitulo">Visitante: <strong>{{ visitantes[0].nomeCompleto }}</strong></p>
        <p v-else-if="visitantes.length > 1" class="subtitulo">Visita em grupo: histórico por visitante</p>
      </div>
    </div>

    <div class="margem container">
      <div v-if="carregando" class="bloco margem alinha-centro">
        <i class="fas fa-spinner fa-spin"></i> Carregando...
      </div>
      <template v-else>
        <div v-for="(bloco, idx) in visitantes" :key="idx" class="bloco margem bloco-visitante">
          <h3 class="bloco-visitante-titulo">
            <i class="fa-solid fa-user"></i> {{ bloco.nomeCompleto }}
          </h3>
          <table class="tabela historico-tabela">
            <thead>
              <tr>
                <template v-if="!permissoes.includes(256)">
                  <th>Empresa</th>
                  <th>Status</th>
                </template>
                <template v-else>
                  <th>Data da visita</th>
                  <th>Horário</th>
                  <th>Empresa / Setor</th>
                  <th>Motivo</th>
                  <th>Status</th>
                  <th>Ações</th>
                </template>
              </tr>
            </thead>
            <tbody>
              <tr v-for="v in bloco.visitas" :key="v.id" :class="{ atual: v.id === idVisita }">
                <template v-if="!permissoes.includes(256)">
                  <td>{{ v.empresaOrigem || "—" }}</td>
                  <td>
                    <span class="badge-status" :class="classeStatus(v.statusAgendamento)">{{ textoStatus(v.statusAgendamento) }}</span>
                  </td>
                </template>
                <template v-else>
                  <td>{{ formatarData(v.dataVisita) }}</td>
                  <td>{{ v.horarioEntradaPrevisto || "—" }} {{ v.horarioSaidaPrevisto ? "– " + v.horarioSaidaPrevisto : "" }}</td>
                  <td>{{ v.empresaOrigem || "—" }} <span v-if="v.areaSetorVisitado" class="setor">/ {{ v.areaSetorVisitado }}</span></td>
                  <td class="motivo">{{ v.motivoVisita || "—" }}</td>
                  <td>
                    <span class="badge-status" :class="classeStatus(v.statusAgendamento)">{{ textoStatus(v.statusAgendamento) }}</span>
                  </td>
                  <td>
                    <router-link :to="'/acesso/checklist/' + v.id" class="link-acao">Check list</router-link>
                    <router-link :to="'/acesso/visita/' + v.id + '/dados-completos'" class="link-acao">Dados</router-link>
                  </td>
                </template>
              </tr>
            </tbody>
            <tbody v-if="bloco.visitas.length === 0">
              <tr>
                <td :colspan="permissoes.includes(256) ? 6 : 2" class="alinha-centro">Nenhuma visita encontrada no histórico deste visitante.</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-if="visitantes.length === 0 && !carregando" class="bloco margem alinha-centro">
          Nenhum visitante encontrado para esta solicitação.
        </div>
        <div class="acoes">
          <button type="button" class="btn-voltar" @click="voltarAnterior">
            <i class="fa-solid fa-arrow-left"></i> Voltar à tela anterior
          </button>
        </div>
      </template>
    </div>
  </section>
</template>

<script>
import { createToaster } from "@meforma/vue-toaster";
import solicitacaoVisitaService from "@/services/solicitacao-visita-service";
import { getPermissao } from "@/services/permissaoService";

import { textoStatus as textoStatusConfig, classeStatus as classeStatusConfig } from "@/config/status-visita";

const toaster = createToaster({ position: "top-right" });

export default {
  name: "HistoricoVisitasView",

  data() {
    return {
      visitantes: [],
      carregando: true,
      permissoes: [],
    };
  },

  computed: {
    idVisita() {
      return this.$route.params.id || null;
    },
    voltarFallbackUrl() {
      return this.idVisita ? `/acesso/checklist/${this.idVisita}` : "/agenda";
    },
  },

  async created() {
    this.permissoes = await getPermissao();
    this.carregar();
  },

  methods: {
    voltarAnterior() {
      if (typeof window !== "undefined" && window.history.length > 1) {
        this.$router.back();
        return;
      }
      this.$router.push(this.voltarFallbackUrl);
    },
    formatarData(val) {
      if (!val) return "—";
      const d = new Date(val);
      if (isNaN(d.getTime())) return String(val);
      return d.toLocaleDateString("pt-BR");
    },
    textoStatus(s) {
      return textoStatusConfig(s);
    },
    classeStatus(s) {
      return classeStatusConfig(s);
    },
    async carregar() {
      if (!this.idVisita) {
        this.carregando = false;
        return;
      }
      this.carregando = true;
      try {
        const res = await solicitacaoVisitaService.listarHistoricoPorVisitaId(this.idVisita);
        this.visitantes = res.visitantes || [];
      } catch (err) {
        console.error(err);
        toaster.show("Erro ao carregar histórico.", { type: "error" });
      } finally {
        this.carregando = false;
      }
    },
  },
};
</script>

<style scoped>
.link-voltar {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  color: var(--cor-primaria-forte);
  text-decoration: none;
  font-size: 0.95rem;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  font-family: inherit;
}
.link-voltar:hover { text-decoration: underline; }
.subtitulo { margin-top: 0.25rem; font-size: 0.95rem; color: var(--cor-fonte-fraca); }
.bloco-visitante { margin-bottom: 2rem; }
.bloco-visitante-titulo {
  font-size: 1rem;
  margin-bottom: 0.75rem;
  color: var(--cor-fonte-forte);
  padding-bottom: 0.5rem;
  border-bottom: 1px solid var(--cor-separador);
}
.bloco-visitante-titulo i { margin-right: 0.5rem; color: var(--cor-primaria-forte); }
.historico-tabela { width: 100%; border-collapse: collapse; }
.historico-tabela th {
  text-align: left;
  padding: 0.75rem;
  background: var(--cor-fonte-forte);
  color: var(--cor-bg);
  font-weight: 600;
}
.historico-tabela td { padding: 0.75rem; border-bottom: 1px solid var(--cor-separador); }
.historico-tabela tr.atual { background: var(--cor-primaria-fraca); }
.setor { font-size: 0.9em; color: var(--cor-fonte-fraca); }
.motivo { max-width: 220px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.badge-status { padding: 0.25rem 0.5rem; border-radius: 6px; font-size: 0.85rem; }
.status-pendente { background: var(--cor-cinza); color: var(--cor-fonte-fraca); }
.status-processo { background: var(--cor-primaria-fraca); color: var(--cor-primaria-forte); }
.status-confirmada { background: var(--cor-primaria-fraca); color: var(--cor-primaria-forte); }
.status-em-visita { background: var(--cor-primaria-fraca); color: var(--cor-primaria-forte); }
.status-concluido { background: var(--cor-primaria-fraca); color: var(--cor-sucesso); }
.link-acao { margin-right: 0.5rem; color: var(--cor-primaria-forte); text-decoration: none; }
.link-acao:hover { text-decoration: underline; }
.acoes { margin-top: 1.5rem; }
.btn-voltar {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  background: var(--cor-primaria);
  color: var(--cor-bg);
  border: none;
  border-radius: 24px;
  text-decoration: none;
  font-size: 0.95rem;
  font-weight: 700;
  cursor: pointer;
  font-family: inherit;
}
.btn-voltar:hover { background: var(--cor-primaria-forte); color: var(--cor-bg); }
</style>
